<template>
  <div id="content" class="screenDiv">
    <Row>
      <Col span="24" style="padding-bottom:10px;">
      <div class="gradeBox gradeBoxOne">
        <div class="grade">年级：</div>
        <div class="gradeNameBox">
          <div class="gradeName" :class="isChoseGrade?'':'isChose'" v-show="!isShowStyle" @click="choseGrade(null,null,null)"
            v-if="!isQuestionBank">全部</div>
          <div class="gradeName" v-for="(grade,index) in gradeInfo" :key="grade.id" :class="grade.id==isGrade?'bg':''"
            @click="choseGrade(index,grade.id,grade.gradeId)">{{grade.name}}</div>
        </div>
      </div>
      <div class="gradeBox">
        <div class="grade">学科：</div>
        <div class="gradeNameBox">
          <div class="gradeName" :class="isChoseSubject?'':'isChose'" v-show="!isShowStyle" @click="choseSubject(null,null,null)"
            v-if="!isQuestionBank">全部</div>
          <div class="gradeName" v-for="(subject,index) in subjectInfo" :key="subject.id" :class="subject.id==isSubject?'bg':''"
            @click="choseSubject(index,subject.id,subject.subjectId)">{{subject.name}}</div>
        </div>
      </div>
      <div class="gradeBox">
        <div class="grade">版本：</div>
        <div class="gradeNameBox">
          <div class="gradeName" :class="isChoseVersion?'':'isChose'" v-show="!isShowStyle" v-if="!isQuestionBank"
            @click="choseVersion(null,null)">全部</div>
          <div class="gradeName" v-for="(version,index) in versionInfo" :key="version.id" :class="version.id==isVersion?'bg':''"
            @click="choseVersion(index,version.id)">{{version.name}}</div>
        </div>
      </div>
      <div class="gradeBox" v-if="isShowStyle || isQuestionBank" v-show="!isTestPaper">
        <div class="grade">教材：</div>
        <div class="gradeNameBox">
          <div class="gradeName" :class="isChoseMaterial?'':'isChose'" v-show="!isShowStyle " v-if="!isQuestionBank">全部</div>
          <div class="gradeName" v-for="(material,index) in materialInfo" :key="material.id" :class="index==isMaterial?'bg':''"
            @click="choseMaterial(index,material.id)">{{material.name}}</div>
        </div>
      </div>
      <!-- 试卷库 类型 -->
      <div class="gradeBox" v-show="isTestPaper">
        <div class="grade">类型：</div>
        <div class="gradeNameBox">
          <div class="gradeName" v-for="(style,index) in testPaperTypeInfo" :key="style.id" :class="style.id==isTestPaperId?'bg':''"
            @click="choseTest(index,style.id)">{{style.name}}</div>
        </div>
      </div>
      </Col>
      <Col span="0">
      <div class="openScreen" @click="showSreen()">
        <div class="openScreenBox">
          {{isOpenScreen?'展开':'收起'}}
          <img class="isOpenImg" :src="isOpenImgSrc" alt="">
        </div>

      </div>
      </Col>
    </Row>

  </div>
</template>
<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js'
  export default {
    name: 'microClassScreen',
    props: {
      isShowStyle: { //同步资源
        type: Boolean,
        default: false
      },
      isPackage: {
        type: Boolean,
        default: false
      },
      isTestPaper: {
        type: Boolean,
        default: false
      },
      isQuestionBank: {
        type: Boolean,
        default: false
      },
      isAreaQuality: {
        type: Boolean,
        default: false
      },
      fromIndexRes: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        urlHttp: '/testIp',
        gradeInfo: null, //年级 信息
        subjectInfo: null, //学科 信息
        versionInfo: null, //版本 信息
        materialInfo: null, //教材 信息
        isChoseGrade: false, //是否选择 年级 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseSubject: false, //是否选择 学科 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseVersion: false, //是否选择 版本 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseMaterial: false, //是否选择 教材 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseStyle: false, //是否选择 类型 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseVolume: false, //是否选择 册别 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseTest: false, //是否选择 试卷类型 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isChoseType: false, //是否选择 类型（备课包） 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
        isGrade: null, //年纪筛选条件 初始默认选择全部
        isSubject: null, //学科筛选条件 初始默认选择全部
        isVersion: null, //版本筛选条件 初始默认选择全部
        isMaterial: 0, //教材筛选条件 初始默认选择全部
        isStyle: 1, //教材类型条件 初始默认选择全部
        isTestPaperId: null,
        isVolume: null, //册别类型条件 初始默认选择全部
        isType: null, //类型（备课包)条件 初始默认选择全部
        isOpenScreen: true,
        isOpenImgSrc: '/static/images/open.png',
        screenDiv: '120px', //筛选框初始高度
        styleArray: [ // 类型
          {
            name: '课件',
            id: '1'
          },
          {
            name: '学案',
            id: '2'
          },
          {
            name: '微课',
            id: '3'
          },
          {
            name: '其他',
            id: '4'
          }
        ],
        volumeInfo: [ //册别
          {
            name: '全一册',
            id: '1'
          },
          {
            name: '上册',
            id: '2'
          },
          {
            name: '下册',
            id: '3'
          }
        ],
        typeInfo: [{
            name: '同步课',
            id: '1'
          },
          {
            name: '专题课',
            id: '2'
          }
        ],
        testPaperTypeInfo: [{
            name: '全部',
            id: null
          },
          // {
          //   name: '周测',
          //   id: '1'
          // },
          // {
          //   name: '月测',
          //   id: '2'
          // },
          {
            name: '章节测',
            id: '3'
          },
          {
            name: '期中',
            id: '4'
          },
          {
            name: '期末',
            id: '5'
          },
          // {
          //   name: '统考',
          //   id: '6'
          // },
          {
            name: '中考',
            id: '7'
          }
          // {
          //   name: '专项训练',
          //   id: '8'
          // }
        ],
        gradeId: null,
        subjectId: null,
        versionId: null,
        isShowComponent: false

      }
    },
    mounted() {
      this.selectQcrPublic('grade_id');
      // this.getGradeData();
      // this.getSubjectData();
      // this.getVersionData();
      if (this.fromIndexRes != null) {
        if (this.fromIndexRes.isFromIndexSyn == 'SynchronizeResources') {
          if (this.fromIndexRes.subjectId == 79) {
            this.isVersion = 5;
            this.versionId = 5;
          }
          if (this.fromIndexRes.subjectId == 83) {
            this.isGrade = 84;
            this.gradeId = 84;
          }
          this.$nextTick(() => {
            bus.$emit('tbSubjectId', this.fromIndexRes.subjectId)
            if (this.fromIndexRes.subjectId == 79) {
              bus.$emit('tbVersionId', 5)
            }
            if (this.fromIndexRes.subjectId == 83) {
              bus.$emit('tbGradeId', 84)
            }

          })
        } else if (this.fromIndexRes.isFromIndexSyn == 'testPaper') {
          this.$nextTick(() => {
            bus.$emit('testSubjectIdLong', this.fromIndexRes.subjectId)
            if (this.fromIndexRes.subjectId == 83) {
              bus.$emit('tbGradeId', 84)
            }

          })
        } else if (this.fromIndexRes.isFromIndexSyn == 'MicroClass') {

          // this.$nextTick(() => {
          //     bus.$emit('subjectId',this.fromIndexRes.subjectId)
          // })
          this.$emit('subjectIdIndex', this.fromIndexRes.subjectId)
          this.isShowComponent = true;

        }
        if (this.fromIndexRes.subjectId == 83) {
          this.isGrade = 84;
          this.gradeId = 84;
          this.isVersion = 4;
          this.versionId = 4;
        }
        if (this.fromIndexRes.subjectId == 81) {
          this.isVersion = 4;
          this.versionId = 4;
        }
        this.isSubject = this.fromIndexRes.subjectId;
        this.subjectId = this.fromIndexRes.subjectId;
        // this.fromIndexRes.isFromIndexSyn = null;
      } else {
        this.isChoseSubject = false;
      }
    },
    watch: {

    },
    methods: {
      //获取级联年级信息
      selectQcrPublic(columnName,gradeId,subjectId){
        let that = this;
        const url = '/axt-data/qcr/selectQcrHandout';
        if(localStorage.getItem('websiteId') == undefined || localStorage.getItem('websiteId') == null){
          that.websiteId = 0;
        }else{
          that.websiteId = localStorage.getItem('websiteId');
        }
        let params = {
          pageNo:1,
          pageSize:100,
          websiteId:0,
          gradeId:gradeId,
          subjectId:subjectId,
          columnName:columnName
        }

        api.getListAPI(url,params).then(res => {

          if(res.data.message == 'success'){
            let list = res.data.data;
            if(columnName == 'grade_id') that.getGradeData(list)
            if(columnName == 'subject_id') that.getSubjectData(list)
            if(columnName == 'version_id') that.getVersionData(list)
          }

         }).catch(err => {console.log(err)})
      },
      //获取年级信息
      getGradeData(list) {
        let that = this;
        const url = '/axt-future/grade/selectByIds';
        let params = {
          gradeIds: list + ''
        }
        api.getListAPI(url, params).then(res => {
          //数据处理
          this.gradeInfo = res.data.data;
          that.selectQcrPublic('subject_id',that.gradeId)
          //this.$emit('gradeData', that.gradeInfo) //向上传组件传值
        }).catch(err => {
          console.log(err)
        })
      },
      //获取学科信息
      getSubjectData(list) {
        if(list.indexOf(this.subjectId) == -1){
            this.subjectId = null;
            this.isSubject = null;
            this.isChoseSubject = false;
        }
        let that = this;
        const url = '/axt-future/subject/selectByIds';
        let params = {
          subjectIds: list + ''
        }
        // params = this.$qs.stringify(params)
        api.getListAPI(url, params).then(res => {
          that.subjectInfo = res.data.data;
          //this.$emit('subjectData', this.subjectInfo)
          that.selectQcrPublic('version_id',that.gradeId,that.subjectId)
          bus.$emit('testSubjectId',that.subjectId)
          bus.$emit('testSubjectIdLong',that.subjectIdLong)
        }).catch(err => {
          console.log(err)
        })
      },
      //获取版本信息
      getVersionData(list) {
        if(list.indexOf(this.versionId) == -1){
            this.versionId = null;
            this.isVersion = null;
            this.isChoseVersion = false;
        }
        let that = this;
        const url = '/axt-future/version/selectByIds';
        let params = {
          versionIds:list + ''
        }
        // params = this.$qs.stringify(params)
        api.getListAPI(url, params).then(res => {
          that.versionInfo = res.data.data;
          this.$emit('versionData', this.versionInfo)
          bus.$emit('versionId',that.versionId)
        }).catch(err => {
          console.log(err)
        })
      },
      //获取教材信息
      getMaterialData(gradeId, subjectId, versionId) {
        let that = this;
        const url = '/axt-future/liveTeaching/pageWithBaseInfo';
        const params = {
          pageSize: 100,
          pageNo: 1,
          gradeIds: gradeId,
          subjectId: subjectId,
          versionId: versionId
        }
        api.getListAPI(url, params).then(res => {
          if (res.data.data.total == 0) {
            bus.$emit('materialId', 'null');
            this.$emit('goMaterialId', 0)
            that.materialInfo = null;
          } else {
            that.materialInfo = res.data.data.rows;
            bus.$emit('materialId', res.data.data.rows[0].id)
            this.$emit('goMaterialId', res.data.data.rows[0].id)
          }


        }).catch(err => {
          console.log(err)
        })
      },
      //点击年级筛选条件 字体变色
      choseGrade(index, gradeId, gradeIdLong) {
        if (gradeId != null) {
          this.isChoseGrade = true; // 选择筛选条件后 全部按钮置灰
        } else {
          this.isChoseGrade = false;
        }
        this.isGrade = gradeId;
        this.gradeId = gradeId;
        this.selectQcrPublic('subject_id',gradeId,null)
          bus.$emit('testGradeId', gradeId)
          // bus.$emit('testGradeIdLong', gradeIdLong)
      },
      //点击学科筛选条件 字体变色
      choseSubject(index, subjectId, subjectIdLong) {
        if (subjectId != null) {
          this.isChoseSubject = true;
        } else {
          this.isChoseSubject = false;
        }
        this.isSubject = subjectId;
        this.subjectId = subjectId;
        this.selectQcrPublic('version_id',this.gradeId,subjectId)
          bus.$emit('testSubjectId', subjectId)
          bus.$emit('testSubjectIdLong', subjectIdLong)
      },
      //点击版本筛选条件 字体变色
      choseVersion(index,versionId){
          if(versionId != null){
              this.isChoseVersion = true;
          }else{
              this.isChoseVersion = false;
          }
          this.isVersion = versionId;
          this.versionId = versionId;
          bus.$emit('versionId', versionId)
          this.getMaterialData(this.gradeId,this.subjectId,this.versionId);     //教材根据 年级 学科 版本走

      },
      //点击类型筛选条件 字体变色
      choseStyle(index, styleId) {
        this.isStyle = styleId;
        bus.$emit('stylelId', styleId)
      },
      //选择 试卷库类型
      choseTest(index, testId) {
        this.isTestPaperId = testId;
        this.isChoseStyle = true;
        bus.$emit('testPaperId', testId)
      }
    }
  }
</script>
<style lang="">
  .screenDiv {
    width: 100%;
    border: 1px solid #DADADA;
    border-radius: 6px;
    color: #666;
    font-size: 14px;
    /* overflow: hidden; */
  }

  .gradeBox {
    width: 100%;
    min-height: 30px;
    padding: 5px 0 0 0;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    line-height: 30px;
    white-space: normal；
  }

  .gradeBoxOne {
    padding-top: 10px;
  }

  .gradeBox .ivu-input-with-suffix {
    padding-right: 0px;
  }

  .gradeBox .ivu-input-suffix:hover {
    cursor: pointer;
  }

  .gradeNameBox {
    overflow: hidden;
  }

  .grade {
    float: left;
    min-width: 70px;
    padding-left: 5px;
  }

  .gradeName {
    float: left;
    min-width: 45px;
    margin: 0 10px;
    padding: 0 5px;
    text-align: left;
  }

  .gradeName:hover {
    cursor: pointer;
    color: #343434;
    border-radius: 5px;
    background: #EEF5FF;
  }

  .isChose {
    color: #3683FF;
  }

  .openScreen {
    width: 100%;
    min-height: 120px;
    position: relative;
    color: #3583FF;
  }

  .openScreenBox {
    position: absolute;
    bottom: 15px;
    right: 30px;
  }

  .openScreenBox:hover {
    cursor: pointer;
  }

  .isOpenImg {
    width: 14px;
    height: 9px;
  }

  .bg {
    color: #3583FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/MicroClassScreen/testPaperScreen.vue